export default {
    FULL_NAME: 'Puno ime',
    NAME: 'Naziv',
    EMAIL: 'Email',
    COMPANY: 'Kompanija',
    CREATION_DATE: 'Datum kreiranja',
    PHONE: 'Telefon',
    ACTIONS: 'Akcije',
    COMPANY_OWNER: 'Vlasnik',
    DOMAIN: 'Domen',
    DEVICE_ID: 'ID uređaja',
    STATUS: 'Status',
    CONNECTED_ACCOUNT: 'Povezani nalog',
    ADDRESS: 'Adresa',
    CITY: 'Grad',
    TERMINAL: 'Terminal',
    CATEGORY: 'Kategorija',
    PRICE: 'Cena',
    DISCOUNTED_PRICE: 'Snižena cena',
    AVAILABILITY: 'Dostupnost',
    MULTI_SELECT: 'Više selekcija',
    MAX_SELECTIONS: 'Max broj selekcija',
    TYPE: 'Tip',
    PAGE: 'Stranica',
    START_DATE: 'Datum početka',
    END_DATE: 'Datum završetka',
    END_USER: 'Krajnji korisnik',
    TOTAL_PRICE: 'Ukupna cena',
    ORDER_STATUS: 'Status porudžbine',
    DELIVERY_METHOD: 'Način isporuke',
    PAYMENT_METHOD: 'Način plaćanja',
};
